import React, { PropTypes, Component } from 'react';
import Portal from 'components/Portal';
import { findDOMNode } from 'react-dom';

const styles = {
  root: {
    zIndex: 102,
    position: 'relative'
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    opacity: 0,
    willChange: 'opacity',
    transform: 'translate3d(0,0,0)',
    transition:
      'left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  open: {
    left: 0,
    opacity: 1
  }
};

const isNodeInRoot = (child, root) => {
  let node = child;
  while (child) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

export default class Overlay extends Component {
  static displayName = 'Overlay';

  static propTypes = {
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    style: PropTypes.object,
    zIndex: PropTypes.number,
    open: PropTypes.bool,
    children: PropTypes.node
  };

  constructor() {
    super(...arguments);
    this.state = {
      open: this.props.open
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.state.open) {
      this.open();
    } else if (!nextProps.open && this.state.open) {
      this.close();
    }
  }

  handleKeyDown = e => {
    if (e.keyCode === 27 && this.state.open) {
      this.close();
    }
  };

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  getStyle(open) {
    const { zIndex, style } = this.props;
    return Object.assign(
      {},
      {
        zIndex
      },
      styles.root,
      open ? styles.open : {},
      style
    );
  }

  getOverlayStyle(open) {
    return Object.assign({}, styles.overlay, open ? styles.open : {});
  }

  closeOverlay(e) {
    this.close();
    e.stopPropagation();
    e.preventDefault();
  }

  close() {
    if (this.state.open) {
      this.setState({ open: false });
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }

  open(force = false) {
    if (!this.state.open) {
      this.setState({ open: true });
      if (this.props.onOpen) {
        this.props.onOpen();
      }
    } else if (force) {
      if (this.props.onOpen) {
        this.props.onOpen();
      }
    }
  }

  toggle() {
    if (this.state.open) {
      this.close();
    } else {
      this.open();
    }
  }

  handleOutsideMouseClick(e) {
    if (isNodeInRoot(e.target, findDOMNode(this.refs.panel))) {
      return;
    }
    this.close();
  }

  render() {
    const { open } = this.state;
    const { children } = open ? this.props : {};
    return (
      <Portal style={styles.root}>
        <div
          onTouchTap={this.closeOverlay.bind(this)}
          style={this.getOverlayStyle(open)}
        />
        {children}
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Overlay.js